/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";

import Alert from "@mui/material/Alert";

import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";

function MsgResultatQuery({ data, idTraza }) {
  const [open] = React.useState(true);

  const msgResultat =
    "S'han trobat " + data + " resultats amb el ID " + idTraza;

  return (
    <Collapse in={open}>
      <Alert
        severity="info"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
          ></IconButton>
        }
        sx={{ marginBottom: -5 }}
      >
        {msgResultat}
      </Alert>
    </Collapse>
  );
}

export default MsgResultatQuery;
